import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        clickState: true,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202103080001', { defaultText: '标识编码' }),
                align: 'center',
                prop: 'identityCode',
                filter: true,
                require: true,
                width: 150
            },
            {
                label: $translate('lang.E3202103080008', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'productCode',
                filter: true,
                require: true,
                width: 150
            },
            {
                label: $translate('lang.E3202103080002', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'productName',
                filter: true,
                require: true,
                width: 180
            },
            {
                label: $translate('lang.E3202103080009', { defaultText: '产品模板编码' }),
                align: 'center',
                prop: 'productTemplateCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103080003', { defaultText: '产品模板' }),
                align: 'center',
                prop: 'productTemplateName',
                filter: true,
                require: true,
                width: 130
            },
            {
                label: $translate('lang.E3202103080010', { defaultText: '标识规则' }),
                align: 'center',
                prop: 'identityRule',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103080011', { defaultText: '打印次数' }),
                align: 'center',
                prop: 'printNumber',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103080012', { defaultText: '企业前缀' }),
                align: 'center',
                prop: 'prefixCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202102250026', { defaultText: '创建人' }),
                align: 'center',
                prop: 'createUserName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202102250027', { defaultText: '创建时间' }),
                align: 'center',
                prop: 'createTime',
                filter: true,
                require: true,
                width: 150
            },
            {
                label: $translate('lang.E3202101250010', { defaultText: '状态' }),
                align: 'center',
                type: '',
                prop: 'status',
                filter: true,
                require: true,
                statesY: $translate('lang.E3202102260004', { defaultText: '启用' }),
                statesN: $translate('lang.E3202102260003', { defaultText: '停用' }),
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
